
const ValidateSelectList = (value) => {

  if (!value ) {
    return 'Field is required';
  }

  return null;
};

export default ValidateSelectList;



// WEBPACK FOOTER //
// ./src/components/validation/rules/selectList.js